import React from 'react';
import { ImgsViewer } from './react-images-viewer.es.js';
import { useLargeImageViewState } from '../../store/base.js';

export const ImgsViewerWrapper = () => {
  const { largeViewerVisible, imgs, currentViewIndex, setCurrentViewIndex, setLargeViewerVisible } =
    useLargeImageViewState();

  return (
    <ImgsViewer
      imgs={imgs}
      currImg={currentViewIndex}
      backdropCloseable
      isOpen={largeViewerVisible}
      onClickPrev={() => {
        setCurrentViewIndex(currentViewIndex - 1);
      }}
      onClickNext={() => {
        setCurrentViewIndex(currentViewIndex + 1);
      }}
      onClose={() => setLargeViewerVisible(false)}
    ></ImgsViewer>
  );
};
